module.exports = __webpack_public_path__ + "assets/media/bolt-trio-teal.15fce2eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/VideoInstallStep/bolt-trio-teal.svg
// module id = 3086
// module chunks = 0